/* ============================================
   Trident Vodka - Shopify Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  /* ------------------------------------------
     Age Gate
     ------------------------------------------ */
  var AGE_VERIFIED_KEY = 'trident_age_verified';

  function initAgeGate() {
    var overlay = document.getElementById('age-gate');
    if (!overlay) return;

    // Check if already verified
    try {
      if (localStorage.getItem(AGE_VERIFIED_KEY) === 'true') {
        overlay.hidden = true;
        return;
      }
    } catch (e) {
      // localStorage not available
    }

    // Show the gate
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';

    var verifyView = document.getElementById('age-gate-verify');
    var deniedView = document.getElementById('age-gate-denied');
    var rememberCheckbox = document.getElementById('age-gate-remember');

    var yesBtn = overlay.querySelector('[data-age-gate="yes"]');
    var noBtn = overlay.querySelector('[data-age-gate="no"]');

    if (yesBtn) {
      yesBtn.addEventListener('click', function () {
        try {
          if (rememberCheckbox && rememberCheckbox.checked) {
            localStorage.setItem(AGE_VERIFIED_KEY, 'true');
          }
        } catch (e) {}
        overlay.hidden = true;
        document.body.style.overflow = '';
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', function () {
        if (verifyView) verifyView.hidden = true;
        if (deniedView) deniedView.hidden = false;
      });
    }
  }

  /* ------------------------------------------
     Mobile Menu
     ------------------------------------------ */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('mobile-nav');
    if (!toggle || !nav) return;

    var iconOpen = toggle.querySelector('.menu-icon-open');
    var iconClose = toggle.querySelector('.menu-icon-close');
    var isOpen = false;

    toggle.addEventListener('click', function () {
      isOpen = !isOpen;
      if (isOpen) {
        nav.classList.add('open');
      } else {
        nav.classList.remove('open');
      }
      if (iconOpen) iconOpen.hidden = isOpen;
      if (iconClose) iconClose.hidden = !isOpen;
    });

    // Close on link click
    var links = nav.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        isOpen = false;
        nav.classList.remove('open');
        if (iconOpen) iconOpen.hidden = false;
        if (iconClose) iconClose.hidden = true;
      });
    }
  }

  /* ------------------------------------------
     Parallax Bottle
     ------------------------------------------ */
  function initParallax() {
    var bottle = document.querySelector('[data-parallax-bottle]');
    if (!bottle) return;

    function onScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      var windowHeight = window.innerHeight;

      if (scrollY < windowHeight) {
        var progress = scrollY / windowHeight;
        var translateY = progress * 150;
        var scale = 1.0 + progress * 0.15;
        bottle.style.transform = 'translate(-50%, calc(-50% + ' + translateY + 'px)) scale(' + scale + ')';
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------
     Quantity Selectors
     ------------------------------------------ */
  function initQuantitySelectors() {
    var selectors = document.querySelectorAll('[data-quantity-selector]');
    for (var s = 0; s < selectors.length; s++) {
      (function (selector) {
        var input = selector.querySelector('[data-quantity-input]');
        var minusBtn = selector.querySelector('[data-quantity-minus]');
        var plusBtn = selector.querySelector('[data-quantity-plus]');

        if (!input || !minusBtn || !plusBtn) return;

        var min = parseInt(input.min) || 1;
        var max = parseInt(input.max) || 99;

        function update(val) {
          var clamped = Math.min(Math.max(val, min), max);
          input.value = clamped;
          minusBtn.disabled = clamped <= min;
          plusBtn.disabled = clamped >= max;
        }

        minusBtn.addEventListener('click', function () {
          update(parseInt(input.value) - 1);
        });

        plusBtn.addEventListener('click', function () {
          update(parseInt(input.value) + 1);
        });

        input.addEventListener('change', function () {
          update(parseInt(input.value) || min);
        });

        // Set initial state
        update(parseInt(input.value) || min);
      })(selectors[s]);
    }
  }

  /* ------------------------------------------
     Cart Drawer (AJAX Cart)
     ------------------------------------------ */
  var cartState = {
    isOpen: false,
    isLoading: false,
    cart: null
  };

  function getCartDrawerElements() {
    return {
      overlay: document.getElementById('cart-drawer'),
      items: document.getElementById('cart-line-items'),
      empty: document.getElementById('cart-empty-state'),
      footer: document.getElementById('cart-drawer-footer'),
      subtotal: document.getElementById('cart-subtotal-amount'),
      checkout: document.getElementById('cart-checkout-link'),
      loading: document.getElementById('cart-loading'),
      count: document.getElementById('header-cart-count')
    };
  }

  function openCart() {
    var el = getCartDrawerElements();
    if (!el.overlay) return;
    cartState.isOpen = true;
    el.overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    var el = getCartDrawerElements();
    if (!el.overlay) return;
    cartState.isOpen = false;
    el.overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function setCartLoading(loading) {
    cartState.isLoading = loading;
    var el = getCartDrawerElements();
    if (el.loading) el.loading.hidden = !loading;
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents) || 0;
    var amount = (cents / 100).toFixed(2);
    // Use shop currency - fallback to CHF
    return 'CHF ' + amount;
  }

  function updateCartCount(count) {
    var el = getCartDrawerElements();
    if (el.count) {
      if (count > 0) {
        el.count.textContent = count > 9 ? '9+' : count;
        el.count.hidden = false;
      } else {
        el.count.hidden = true;
      }
    }
  }

  function renderCartItems(cart) {
    cartState.cart = cart;
    var el = getCartDrawerElements();
    if (!el.items || !el.empty || !el.footer) return;

    if (!cart || !cart.items || cart.items.length === 0) {
      el.items.innerHTML = '';
      el.empty.hidden = false;
      el.footer.hidden = true;
      return;
    }

    el.empty.hidden = true;
    el.footer.hidden = false;

    var html = '';
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var lineTotal = formatMoney(item.line_price);
      var unitPrice = formatMoney(item.price);

      var imageHtml = '';
      if (item.image) {
        // Use Shopify's image size parameter
        var imgSrc = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2');
        imageHtml = '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">';
      }

      var variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<p class="variant">' + escapeHtml(item.variant_title) + '</p>';
      }

      html += '<li class="cart-line">' +
        '<div class="cart-line-image">' + imageHtml + '</div>' +
        '<div class="cart-line-details">' +
          '<h3>' + escapeHtml(item.product_title) + '</h3>' +
          variantHtml +
          '<p class="price">' + unitPrice + '</p>' +
          '<div class="cart-line-qty">' +
            '<div class="qty-controls">' +
              '<button type="button" data-line-key="' + item.key + '" data-action="minus" aria-label="Decrease">' +
                '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/></svg>' +
              '</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line-key="' + item.key + '" data-action="plus" aria-label="Increase">' +
                '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>' +
              '</button>' +
            '</div>' +
            '<button type="button" class="cart-line-remove" data-line-key="' + item.key + '" data-action="remove" aria-label="Remove">' +
              '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line-total">' + lineTotal + '</div>' +
      '</li>';
    }

    el.items.innerHTML = html;

    // Subtotal
    if (el.subtotal) {
      el.subtotal.textContent = formatMoney(cart.total_price);
    }

    // Use event delegation for cart item buttons
    el.items.onclick = function (e) {
      var btn = e.target.closest('[data-line-key]');
      if (!btn || cartState.isLoading) return;

      var key = btn.getAttribute('data-line-key');
      var action = btn.getAttribute('data-action');

      if (!key || !action) return;

      // Find current quantity for this item
      var currentQty = 0;
      for (var j = 0; j < cart.items.length; j++) {
        if (cart.items[j].key === key) {
          currentQty = cart.items[j].quantity;
          break;
        }
      }

      if (action === 'minus') {
        updateCartItem(key, Math.max(0, currentQty - 1));
      } else if (action === 'plus') {
        updateCartItem(key, currentQty + 1);
      } else if (action === 'remove') {
        updateCartItem(key, 0);
      }
    };
  }

  function fetchJSON(url, options) {
    var opts = options || {};
    opts.headers = opts.headers || {};
    opts.headers['Accept'] = 'application/json';
    if (opts.body && !opts.headers['Content-Type']) {
      opts.headers['Content-Type'] = 'application/json';
    }
    return fetch(url, opts).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (text) {
          console.error('Cart API error:', res.status, text);
          throw new Error('Cart API error: ' + res.status);
        });
      }
      return res.json();
    });
  }

  function refreshCart() {
    setCartLoading(true);
    fetchJSON('/cart.js')
      .then(function (cart) {
        renderCartItems(cart);
        updateCartCount(cart.item_count);
        setCartLoading(false);
      })
      .catch(function (err) {
        console.error('Failed to fetch cart:', err);
        setCartLoading(false);
      });
  }

  function addToCart(variantId, quantity) {
    setCartLoading(true);
    var id = parseInt(variantId);
    if (isNaN(id)) {
      console.error('Invalid variant ID:', variantId);
      setCartLoading(false);
      return Promise.resolve();
    }

    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: id,
          quantity: quantity || 1
        }]
      })
    })
    .then(function () {
      // Fetch full cart after adding
      return fetchJSON('/cart.js');
    })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
      setCartLoading(false);
      openCart();
    })
    .catch(function (err) {
      console.error('Error adding to cart:', err);
      setCartLoading(false);
      closeCart();
    });
  }

  function updateCartItem(key, quantity) {
    setCartLoading(true);
    fetchJSON('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartCount(cart.item_count);
      setCartLoading(false);
    })
    .catch(function (err) {
      console.error('Error updating cart:', err);
      setCartLoading(false);
    });
  }

  function initCartDrawer() {
    // Open cart buttons
    var openBtns = document.querySelectorAll('[data-cart-open]');
    for (var i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    }

    // Close cart buttons & backdrop
    var closeBtns = document.querySelectorAll('[data-cart-close]');
    for (var j = 0; j < closeBtns.length; j++) {
      closeBtns[j].addEventListener('click', function () {
        closeCart();
      });
    }

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartState.isOpen) {
        closeCart();
      }
    });
  }

  /* ------------------------------------------
     Add to Cart Forms (AJAX Enhancement)
     ------------------------------------------ */
  function initAddToCartForms() {
    // Use event delegation on the document for forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-to-cart-form]');
      if (!form) return;

      e.preventDefault();

      var btn = form.querySelector('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      var variantId = idInput.value;
      var qtyInput = form.querySelector('[data-quantity-input]') || form.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      // Show loading state on button
      var originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.style.opacity = '0.7';
      btn.innerHTML = '<svg class="animate-spin" style="width:1.25rem;height:1.25rem;" fill="none" viewBox="0 0 24 24"><circle opacity="0.25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path opacity="0.75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';

      function restoreButton() {
        btn.innerHTML = originalHtml;
        btn.disabled = false;
        btn.style.opacity = '';
      }

      // Safety timeout: always restore button after 5 seconds
      var timeout = setTimeout(restoreButton, 5000);

      var promise = addToCart(variantId, quantity);
      if (promise && typeof promise.then === 'function') {
        promise
          .then(function () {
            clearTimeout(timeout);
            restoreButton();
          })
          .catch(function () {
            clearTimeout(timeout);
            restoreButton();
          });
      } else {
        clearTimeout(timeout);
        restoreButton();
      }
    });
  }

  /* ------------------------------------------
     Helpers
     ------------------------------------------ */
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ------------------------------------------
     Initialize Everything on DOM Ready
     ------------------------------------------ */
  function init() {
    initAgeGate();
    initMobileMenu();
    initParallax();
    initQuantitySelectors();
    initCartDrawer();
    initAddToCartForms();

    // Update cart count on page load
    fetchJSON('/cart.js')
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
